// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blessing_header__RHVUJ {
    height: 70vh;
    width: 80%;
    margin: auto;
    text-align: left;
    display: 'flex';
    justify-content: space-between;
}

.blessing_texts__N1-TG {
    color: #fcf3dd;
    font-size: 70px;
    /* style={{ color: '#fcf3dd', fontSize: '70px' }} */
    font-family: "cookies";
    color: "#fcf3dd";
}
.blessing_text__SSaTK p{
    font-size: 28px;
}

.blessing_logo__lt6aQ {

    width: 30vw;
    height: auto;
    float: right;
    margin-left: 10%;
    margin-top: 2.5%;
}
.blessing_logo1__zcyoH{
    display: none;
}

.blessing_img__kXkZ4 {
    width: 45%;
    float: left;
    margin-top: 2.5%;
}

.blessing_text__SSaTK {
    display: table-cell;
    width: 30vw;
    height: 450px;
    vertical-align: middle;
    text-align: left;
    background-color: #caaacd;
}

.blessing_input__FhWrk {
    margin-bottom: 2rem;
    display: flex;
    justify-content: space-between;
}

p {
    color: black;
}

.blessing_inputs__uWyDD {
    height: 560px;
    color: black;
    text-align: left;
}

.blessing_ifield__mb7ZN {
    width: 60%;
    padding: 10px;
    margin-right: 5%;
    text-align: center;
    font-size: 1rem;
}

.blessing_submit__epvDP {
    display: flex;
    justify-content: center;
}

.blessing_submitbutton__UyrVz {
    width: 25%;
    margin: 3%;
    cursor: pointer;

}

.blessing_submitbutton__UyrVz:hover {
    transform: scale(1.2);
}


.blessing_icontext__F1xlf {
    font-size: 18px;
    font-weight: 500;
}

.blessing_letter__ojCDF {
    position: absolute;
    top: 680px;
    left: 172px;
    height: 175px;
    width: 314px;
    background-color: #7356BD;
    border: none;
    text-align: center;
    color: #fff;
    padding: 10px;
}
.blessing_icon__BN3Pc h1{
    padding-top:5%;
}



@media (max-width:800px) {


    .blessing_text__SSaTK {
        
        display: inline;
        text-align: left;
      
    }
    .blessing_header__RHVUJ{
        width: 90%;
        height: 27vh;
        padding-top: 4% ;
    }

    .blessing_header__RHVUJ p{
        font-size: 16px;
    }
    .blessing_letter__ojCDF {
        display: none;
    }
    .blessing_ptext__EHzSo{
        display: flex;
    }

    .blessing_img__kXkZ4 {
        display: none;
    }

    .blessing_logo__lt6aQ {
        display: none;
      
    }
    .blessing_logo1__zcyoH{
      display: block;
      width: 25%;
      height: 25%;
      margin-right:10px ;
    }

    .blessing_icon__BN3Pc h1 {
        padding-top: 20px;
        font-size: 22px;
    }
    .blessing_icontext__F1xlf{
        font-size: 12px;
    }

    .blessing_idesc__navRK {
        display: none;
    }

    .blessing_texts__N1-TG {
        margin-top: 0;
        font-size: 30px;
    }
    .blessing_input__FhWrk{
        display: block;
        margin:3%;

    }
    .blessing_ifield__mb7ZN{
        width: 100%;
        margin: 1%;
        text-align: left;
    }
    .blessing_submitbutton__UyrVz{
        width: 50%;
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/Blessings/blessing.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mDAAmD;IACnD,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,UAAU;IACV,eAAe;;AAEnB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;AACA;IACI,cAAc;AAClB;;;;AAIA;;;IAGI;;QAEI,eAAe;QACf,gBAAgB;;IAEpB;IACA;QACI,UAAU;QACV,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;;IAEjB;IACA;MACE,cAAc;MACd,UAAU;MACV,WAAW;MACX,kBAAkB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;IACA;QACI,cAAc;QACd,SAAS;;IAEb;IACA;QACI,WAAW;QACX,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,UAAU;IACd;;AAEJ","sourcesContent":[".header {\n    height: 70vh;\n    width: 80%;\n    margin: auto;\n    text-align: left;\n    display: 'flex';\n    justify-content: space-between;\n}\n\n.texts {\n    color: #fcf3dd;\n    font-size: 70px;\n    /* style={{ color: '#fcf3dd', fontSize: '70px' }} */\n    font-family: \"cookies\";\n    color: \"#fcf3dd\";\n}\n.text p{\n    font-size: 28px;\n}\n\n.logo {\n\n    width: 30vw;\n    height: auto;\n    float: right;\n    margin-left: 10%;\n    margin-top: 2.5%;\n}\n.logo1{\n    display: none;\n}\n\n.img {\n    width: 45%;\n    float: left;\n    margin-top: 2.5%;\n}\n\n.text {\n    display: table-cell;\n    width: 30vw;\n    height: 450px;\n    vertical-align: middle;\n    text-align: left;\n    background-color: #caaacd;\n}\n\n.input {\n    margin-bottom: 2rem;\n    display: flex;\n    justify-content: space-between;\n}\n\np {\n    color: black;\n}\n\n.inputs {\n    height: 560px;\n    color: black;\n    text-align: left;\n}\n\n.ifield {\n    width: 60%;\n    padding: 10px;\n    margin-right: 5%;\n    text-align: center;\n    font-size: 1rem;\n}\n\n.submit {\n    display: flex;\n    justify-content: center;\n}\n\n.submitbutton {\n    width: 25%;\n    margin: 3%;\n    cursor: pointer;\n\n}\n\n.submitbutton:hover {\n    transform: scale(1.2);\n}\n\n\n.icontext {\n    font-size: 18px;\n    font-weight: 500;\n}\n\n.letter {\n    position: absolute;\n    top: 680px;\n    left: 172px;\n    height: 175px;\n    width: 314px;\n    background-color: #7356BD;\n    border: none;\n    text-align: center;\n    color: #fff;\n    padding: 10px;\n}\n.icon h1{\n    padding-top:5%;\n}\n\n\n\n@media (max-width:800px) {\n\n\n    .text {\n        \n        display: inline;\n        text-align: left;\n      \n    }\n    .header{\n        width: 90%;\n        height: 27vh;\n        padding-top: 4% ;\n    }\n\n    .header p{\n        font-size: 16px;\n    }\n    .letter {\n        display: none;\n    }\n    .ptext{\n        display: flex;\n    }\n\n    .img {\n        display: none;\n    }\n\n    .logo {\n        display: none;\n      \n    }\n    .logo1{\n      display: block;\n      width: 25%;\n      height: 25%;\n      margin-right:10px ;\n    }\n\n    .icon h1 {\n        padding-top: 20px;\n        font-size: 22px;\n    }\n    .icontext{\n        font-size: 12px;\n    }\n\n    .idesc {\n        display: none;\n    }\n\n    .texts {\n        margin-top: 0;\n        font-size: 30px;\n    }\n    .input{\n        display: block;\n        margin:3%;\n\n    }\n    .ifield{\n        width: 100%;\n        margin: 1%;\n        text-align: left;\n    }\n    .submitbutton{\n        width: 50%;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `blessing_header__RHVUJ`,
	"texts": `blessing_texts__N1-TG`,
	"text": `blessing_text__SSaTK`,
	"logo": `blessing_logo__lt6aQ`,
	"logo1": `blessing_logo1__zcyoH`,
	"img": `blessing_img__kXkZ4`,
	"input": `blessing_input__FhWrk`,
	"inputs": `blessing_inputs__uWyDD`,
	"ifield": `blessing_ifield__mb7ZN`,
	"submit": `blessing_submit__epvDP`,
	"submitbutton": `blessing_submitbutton__UyrVz`,
	"icontext": `blessing_icontext__F1xlf`,
	"letter": `blessing_letter__ojCDF`,
	"icon": `blessing_icon__BN3Pc`,
	"ptext": `blessing_ptext__EHzSo`,
	"idesc": `blessing_idesc__navRK`
};
export default ___CSS_LOADER_EXPORT___;
